import React, { useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import s from './ProfileSwitch.module.scss';
import cross from '../../assets/cross-small.svg';
import { FormattedMessage } from 'react-intl';

const ProfileSwitch = ({
  selectedProfile,
  profiles,
  onUserProfileChange,
  closePopup,
  selectedOrganisationId,
  organisations,
  fieldType,
  onOrganisationChange
}) => {
  const node = useRef();

  const handleClick = e => {
    if (node.current.contains(e.target)) {
      // inside click
      return;
    }
    // outside click
    closePopup();
  };

  useEffect(() => {
    // add when mounted
    document.addEventListener('mousedown', handleClick);
    // return function to be called when unmounted
    return () => {
      document.removeEventListener('mousedown', handleClick);
    };
  }, []);

  return (
    <div className={s.popup}>
      <div className={s.popup_inner} ref={node}>
        <div className={s.dismiss}>
          <img src={cross} alt="close" onClick={closePopup} />
        </div>
        <div className="mb-3">
          <span>
            <FormattedMessage id="sidebar.switchProfiles" defaultMessage="Switch profiles" />
          </span>
        </div>
        <div className={s.scrollDiv}>
          {profiles &&
            profiles.length > 0 &&
            profiles.map(prof => {
              let profName = prof.Name;
              let checked = false;
              if (!selectedProfile) {
                selectedProfile = profName;
              }
              if (selectedProfile === profName) {
                checked = true;
              }
              return (
                <div className={s.formCheck} key={prof.ProfileId}>
                  <label className={s.container}>
                    <input
                      type="radio"
                      name="user-profiles"
                      value={profName}
                      defaultChecked={checked}
                      onClick={() => {
                        onUserProfileChange(prof);
                      }}
                    />
                    {profName}
                    <span className={s.checkmark}></span>
                  </label>
                </div>
              );
            })}
        </div>
      </div>
    </div>
  );
};

ProfileSwitch.propTypes = {
  selectedProfile: PropTypes.string,
  profiles: PropTypes.array,
  onUserProfileChange: PropTypes.func,
  closePopup: PropTypes.func,
  organisations: PropTypes.array,
  selectedOrganisationId: PropTypes.number,
  fieldType: PropTypes.string,
  onOrganisationChange: PropTypes.func
};

export default ProfileSwitch;
